// extracted by css-extract-rspack-plugin
export default {"box":"DW6yGRW09GCHxXvc"};